<template>
  <div class="same-location-video">
    <template v-if="!isPlaying">
      <picture>
        <source media="(max-width: 767px)" :srcset="videopostermob">
        <img class="video-poster" :src="videoposter" alt="">
      </picture>
      <button
        type="button"
        class="play-button"
        :code-stm="`event, PAGEURL, ${maidiansuffix} 点击封面视频/图片按钮`"
        aria-label="播放视频"
        @click="playVideo"
      >
        <img :src="playicon" alt="">
      </button>
    </template>

    <video
      v-else
      ref="videoPlayer"
      class="video-player"
      :src="videofullsrc"
      :poster="currentPoster"
      controls
      playsinline
      webkit-playsinline="true"
      x5-playsinline="true"
      x5-video-player-type="h5"
      @ended="resetVideo"
    ></video>

    <button
      v-if="isPlaying"
      type="button"
      class="close-button"
      code-stm="event, PAGEURL, 关闭视频按钮"
      aria-label="关闭视频"
      @click="closeVideo"
    >
      <picture>
        <source media="(max-width: 767px)" :srcset="closeiconmob">
        <img :src="closeiconpc" alt="">
      </picture>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BasicSameLocationVideo',
  props: {
    videofullsrc: {
      type: String,
      default: ''
    },
    videoposter: {
      type: String,
      default: ''
    },
    videopostermob: {
      type: String,
      default: ''
    },
    playicon: {
      type: String,
      default: ''
    },
    closeiconpc: {
      type: String,
      default: '/assets/~/media/images/activity/suchao/pc/close.png'
    },
    closeiconmob: {
      type: String,
      default: '/assets/~/media/images/activity/suchao/mob/close.png'
    },
    maidiansuffix: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isPlaying: false,
      observer: null
    }
  },
  computed: {
    currentPoster() {
      return window.matchMedia('(max-width: 767px)').matches
        ? this.videopostermob
        : this.videoposter
    }
  },
  beforeDestroy() {
    this.disconnectObserver()
    this.pauseVideo()
  },
  methods: {
    playVideo() {
      this.isPlaying = true
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer
        if (!video) return

        this.observeVideo(video)

        const playPromise = video.play()
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // 浏览器阻止自动播放时，保留原生控件供用户再次点击。
          })
        }
      })
    },
    observeVideo(video) {
      this.disconnectObserver()
      if (!window.IntersectionObserver) return

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !entry.target.paused) {
            entry.target.pause()
          }
        })
      }, {
        threshold: 0.1
      })
      this.observer.observe(video)
    },
    disconnectObserver() {
      if (!this.observer) return
      this.observer.disconnect()
      this.observer = null
    },
    pauseVideo() {
      const video = this.$refs.videoPlayer
      if (video && !video.paused) {
        video.pause()
      }
    },
    closeVideo() {
      this.pauseVideo()
      this.disconnectObserver()
      this.isPlaying = false
    },
    resetVideo() {
      this.closeVideo()
    }
  }
}
</script>

<style lang="scss" scoped>
.same-location-video {
  position: relative;
  width: 100%;
  aspect-ratio: 1920 / 1000;
  overflow: hidden;
  background: #000;
}

.video-poster,
.video-player,
picture {
  display: block;
  width: 100%;
  height: 100%;
}

.video-poster {
  object-fit: cover;
}

.video-player {
  object-fit: contain;
  background: #000;
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  width: calc(80 / 1920 * 100vw);
  height: calc(80 / 1920 * 100vw);
  padding: 0;
  border: 0;
  background: transparent;
  transform: translate(-50%, -50%);
  cursor: pointer;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.close-button {
  position: absolute;
  top: calc(24 / 1920 * 100vw);
  right: calc(24 / 1920 * 100vw);
  z-index: 2;
  width: calc(40 / 1920 * 100vw);
  height: calc(40 / 1920 * 100vw);
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  picture,
  img {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: contain;
  }
}

@media (max-width: 767px) {
  .same-location-video {
    aspect-ratio: 375 / 455;
  }

  .play-button {
    width: calc(54 / 375 * 100vw);
    height: calc(54 / 375 * 100vw);
  }

  .close-button {
    top: calc(16 / 375 * 100vw);
    right: calc(16 / 375 * 100vw);
    width: calc(32 / 375 * 100vw);
    height: calc(32 / 375 * 100vw);
  }
}
</style>
